import React, { useEffect, useState } from 'react';
import { adminService } from '../../services/adminService';
import Card, { CardContent } from '../../components/ui/Card';
import Button from '../../components/ui/Button';

const AdminCreatorsPage: React.FC = () => {
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const res = await adminService.listPendingCreators();
    setItems(res.creators || []);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const verify = async (id: string) => {
    await adminService.verifyCreator(id);
    await load();
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-2xl font-bold text-gray-900 mb-4">Creator Verification</h1>
      <Card>
        <CardContent>
          {loading ? (
            <div>Loading…</div>
          ) : items.length === 0 ? (
            <div>No pending creators.</div>
          ) : (
            <div className="space-y-4">
              {items.map((c:any)=> (
                <div key={c.id} className="p-4 border rounded-lg flex items-center justify-between">
                  <div>
                    <div className="font-semibold text-gray-900">{c.displayName}</div>
                    <div className="text-sm text-gray-600">{c.user?.username}</div>
                  </div>
                  <Button onClick={()=>verify(c.id)}>Verify</Button>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminCreatorsPage;



